import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Alert,
} from '@mui/material';
import { Home, History } from '@mui/icons-material';
import { EmployeeLayout } from '@/components/Layout';
import { ListingModerationPanel, ModerationAuditLog } from '@/components/admin';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`moderation-tabpanel-${index}`}
      aria-labelledby={`moderation-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const ListingModeration: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
    setError(null); // Clear errors when switching tabs
  };

  const handleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  return (
    <EmployeeLayout>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Home sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
          <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
            Listing Moderation
          </Typography>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={currentTab} onChange={handleTabChange} aria-label="moderation tabs">
            <Tab 
              label="Listing Review" 
              icon={<Home />} 
              iconPosition="start"
              id="moderation-tab-0"
              aria-controls="moderation-tabpanel-0"
            />
            <Tab 
              label="Audit Log" 
              icon={<History />} 
              iconPosition="start"
              id="moderation-tab-1"
              aria-controls="moderation-tabpanel-1"
            />
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <TabPanel value={currentTab} index={0}>
          <ListingModerationPanel onError={handleError} />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <ModerationAuditLog onError={handleError} />
        </TabPanel>
      </Box>
    </EmployeeLayout>
  );
};

export default ListingModeration;